import { api } from './authenticatedApi';

export interface ApiTokenSummary {
  id: string;
  name: string;
  lastEight: string;
  scopes: string[];
  revoked: boolean;
  expiresAt: string | null;
  lastUsedAt: string | null;
  createdAt: string;
}

export interface CreatedApiToken {
  id: string;
  token: string;
  name: string;
  scopes: string[];
  expiresAt: string | null;
  lastEight: string;
}

export class ApiTokenService {
  static async list() {
    return api.get<{ tokens: ApiTokenSummary[] }>('/api-tokens');
  }

  // ttlDays: number = days, null = never expires, omitted = server default
  static async create(data: { name: string; scopes?: string[]; ttlDays?: number | null }) {
    return api.post<CreatedApiToken>('/api-tokens', data);
  }

  static async revoke(id: string) {
    return api.delete(`/api-tokens/${id}`);
  }
}
